module.exports = __webpack_public_path__ + "img/asia-admin10.97028057.png";